// extracted by mini-css-extract-plugin
export var columnList = "_fd-0";